// You can write your custom Javascript here


jQuery( document ).ready( function( $ ) {
  $( '.megamenu__content-head' ).each( function(){

    var allColl = $( this ).closest( '.menu__item--has-dropdown' ).find( 'a' ).attr( 'href' );
    console.log('mine: '+ allColl );

    $( this ).find( 'a' ).attr( 'href', allColl );
  } );

  // var seoHeightMax = $( '.collection-seo-copy' ).height();

  // $( '.collection-seo-copy' ).height( 220 );

  $( '.view-more-seo' ).on( 'click', function( e ) {
    e.preventDefault();

    $(this).text($(this).text() == 'Read Less' ? 'Read More' : 'Read Less');

    $( '.collection-seo-copy .snippet' ).slideToggle();
    $( '.collection-seo-copy .full' ).slideToggle();
    // $( '.collection-seo-wrap' ).animate({
    //   'height': '100%'
    // });
  } );

  $('.sticky-wrap').stickySidebar({
    topSpacing: 90,
    bottomSpacing: 90
});

  // var seoH3Height = $( '.collection-seo-copy h3:first-child' ).outerHeight(true);
  // var seoPHeight = $( '.collection-seo-copy p :first' ).height();

  // var combinedHeight = seoH3Height + seoPHeight;

  // console.log( 'combined: '+ seoPHeight);

  if(getCookie("HideAlertBar") != "true") {
    var noticeH = $('.header__notice').height();
    $('.header__notice').show();

    $('.main').css('padding-top', $('.header').outerHeight());
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
       while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
  } 
  
      var states = {
        WA: [4],
        OR: [3, 4],
        CA: [3, 4],
        ID: [3, 4],
        NV: [3, 4],
        MT: [4, 5],
        WY: [3, 4],
        UT: [3, 4],
        AZ: [3, 4],
        NM: [2, 3],
        CO: [3, 4],
        NE: [2, 3],
        SD: [3],
        ND: [3, 4],
        MN: [2, 3],
        IA: [2, 3],
        WI: [2, 3],
        KS: [2],
        OK: [2],
        TX: [2, 3],
        MO: [1, 2],
        IL: [1, 2],
        IN: [1, 2],
        MI: [2],
        OH: [2],
        KY: [1, 2],
        TN: [1, 2],
        AR: [1],
        LA: [1, 2],
        MS: [1],
        AL: [1, 2],
        GA: [1, 2],
        FL: [2],
        SC: [2],
        NC: [2, 3],
        VA: [2, 3],
        WV: [2],
        DC: [2],
        MD: [2],
        DE: [2],
        NJ: [2, 3],
        CT: [3],
        RI: [3],
        MA: [3],
        VT: [3],
        NH: [3],
        ME: [3],
        NY: [2, 3],
        PA: [2, 3],
        HI: [6, 7],
        AK: [6, 7]
    };

    var month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    var weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  $( '.form--shipping .btn' ).on( 'click', function( e ) {
    var zipVal = $( this ).closest( '.form__body' ).find( 'input' ).val();
    var apiCall = "//maps.googleapis.com/maps/api/geocode/json?address=" + zipVal + "&key=AIzaSyBgjLDQK-Mh8krMTabgMAEqYXQ7MdlEftU";

    $.get( apiCall, function( data, status ) {
      var responseData =  data.results[0].address_components;

      console.log( responseData );

      var daysArray = [];
      
      $.each( responseData, function( index, element ) {
        console.log(  );

        if ( element.types[0] == 'administrative_area_level_1' ) {
          var stateDeliver = element.short_name;
          var deliverDays = states[stateDeliver]; 

          $.each( deliverDays, function( index, days ) {
            var date = new Date();

            date.setDate( date.getDate() + days );

            var dayLogic = weekDays[date.getDay()];

           if( index == 0 && dayLogic == 'Sunday' ) {
            var d = weekDays[date.getDay() + 1];
            var dd = date.getDate() + 1;
           } else if ( index == 1 && dayLogic == 'Monday' ) {
            var d = weekDays[date.getDay() + 1];
            var dd = date.getDate() + 1;
           } else if ( index == 1 && dayLogic == 'Sunday' ) {
            var d = weekDays[date.getDay() + 1];
            var dd = date.getDate() + 1;
            } else {
            var d = weekDays[date.getDay()];
            var dd = date.getDate();
           }
            
           
            
            // var month = date.getMonth();
            var n = month[ date.getMonth() ];
            
           daysArray.push( d + ', ' + n +' '+ dd );
            

          
          } );
        }

        
      } )

      var dayOne = daysArray[0];
      var dayTwo = daysArray[1];

      if ( dayTwo ) {
        var daysList = dayOne + ' or ' +dayTwo;
      } else {
        var daysList = dayOne;
      }

      $( '.modal-shipping-results p span' ).text( daysList + '*' );
      $( '.modal .form--shipping' ).fadeOut( 'fast', function(){
        $( '.modal-shipping-results' ).fadeIn();
      });
      
    } );

  } );

  $( '.modal-shipping-results .zip-change' ).on( 'click', function( e ) {
    e.preventDefault();

    $( '.modal-shipping-results' ).fadeOut( 'fast', function(){
      $( '.modal .form--shipping' ).fadeIn();
    });
  });

  $( '.template-product .email-reminder' ).on( 'click', function( e ) {
    e.preventDefault();

    $( '.BIS_trigger' ).click();
  });

  // $( '.boost-pfs-filter-product-item  .email-reminder span' ).on( 'click', function( e ) {
  //   e.preventDefault();

  //   $( this ).closest( '.BIS_trigger' ).click();
  // });


} )


jQuery( document ).ready( function( $ ) {

    /*Ninja price update */
    var targetNodes = $(".subscribe__body");
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var bundleObersrver = new MutationObserver(mutationHandler);
    var obsConfig = {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true
    }; //--- Add a target node to the observer. Can only add one node at a time.

    targetNodes.each(function() {
        bundleObersrver.observe(this, obsConfig);
    });

    function mutationHandler(mutationRecords) {
        //loop through all the mutations that just occured
        mutationRecords.forEach(function(mutation) {
            if (mutation.type == "childList") {
                //loop though the added nodes
                mutation.addedNodes.forEach(function(added_node) {
                  

                    if ($(".needsclick").html() != undefined) {
                       
$("img.needsclick").attr("alt","Seismic Audio Logo");
                        bundleObersrver.disconnect();
                    }





                });
            }
        });
    }


    var targetNodes2 = $("body");
    var MutationObserver2 = window.MutationObserver2 || window.WebKitMutationObserver;
    var bundleObersrver2 = new MutationObserver2(mutationHandler2);
    var obsConfig2 = {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true
    }; //--- Add a target node to the observer. Can only add one node at a time.

    targetNodes2.each(function() {
        bundleObersrver2.observe(this, obsConfig2);
    });
    function mutationHandler2(mutationRecords2) {
      //loop through all the mutations that just occured
      mutationRecords2.forEach(function(mutation) {
          if (mutation.type == "childList") {
              //loop though the added nodes
              mutation.addedNodes.forEach(function(added_node) {
                 
                  if ($(".rebuy-product-info").html() != undefined) {
                    setTimeout(function() {
                      $(".rebuy-product-info").find("a").removeAttr("aria-level");
                  }, 1000); 

bundleObersrver2.disconnect();
                  }





              });
          }
      });
  }
  })

  
jQuery( document ).ready( function( $ ) {
 
var targetNodes2 = $(".template-search");
    var MutationObserver2 = window.MutationObserver2 || window.WebKitMutationObserver;
    var bundleObersrver2 = new MutationObserver2(mutationHandler2);
    var obsConfig2 = {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true
    }; //--- Add a target node to the observer. Can only add one node at a time.

    targetNodes2.each(function() {
        bundleObersrver2.observe(this, obsConfig2);
    });
    function mutationHandler2(mutationRecords2) {
      //loop through all the mutations that just occured
      mutationRecords2.forEach(function(mutation) {
          if (mutation.type == "childList") {
              //loop though the added nodes
              mutation.addedNodes.forEach(function(added_node) {
                console.log($(".boost-pfs-filter-option-item").html());
                  if ($(".boost-pfs-filter-option-item").html() != undefined) {
                    
                    $(".boost-pfs-filter-option-item").each(function() {
                      $(this).find(".boost-pfs-filter-button").attr("aria-checked","false");
                    })
bundleObersrver2.disconnect();
                  }
              });
          }
      });
  }
})